import { render, staticRenderFns } from "./TemporaryTokenSignin.vue?vue&type=template&id=3606d585&scoped=true&"
import script from "./TemporaryTokenSignin.vue?vue&type=script&lang=js&"
export * from "./TemporaryTokenSignin.vue?vue&type=script&lang=js&"
import style0 from "./TemporaryTokenSignin.vue?vue&type=style&index=0&id=3606d585&prod&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3606d585",
  null
  
)

/* custom blocks */
import block0 from "./TemporaryTokenSignin.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports